import NavigateMenu, {NavigateMenuProps} from "./NavigateMenu";

export default NavigateMenu;
export type {NavigateMenuProps};
